import styled from 'styled-components';

import bgHome from '../../assets/images/bg-home.svg';

export const Container = styled.div`
  a {
    width: 100%;
    color: inherit;
    text-decoration: none;
  }

  width: 100%;
  height: 100%;
  overflow: auto;
  background: url(${bgHome}) no-repeat center;
  background-size: cover;
`;

export const Body = styled.section`
  width: 100%;
  background-color: transparent;

  .welcomeHeader {
    text-align: center;

    h1 {
      font-weight: bold;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      font-size: 24px;
      color: #8b0304;
    }

    hr {
      width: 35px;
      height: 5px;
      background-color: #8b0304;
      border: 0;
    }
  }

  .actions {
    width: 80%;
    margin: 0 auto;
    padding-top: 50px;
    display: flex;
    gap: 15px;
    text-align: center;

    div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 174px;

      .imgBox {
        background: #ffffffa6;
        padding: 35px;
        box-shadow: #909090 0px 0px 10px -2px;
        transition: 0.5s;

        img {
          max-width: 60px;
          min-height: 61.06px;
        }

        h1 {
          text-transform: uppercase;
          font-weight: 700;
          color: #dddddd;
          margin-top: 20px;
        }
      }

      .imgBox:hover {
        box-shadow: #909090 0px 0px 15px -2px;
      }

      p {
        font-size: 12px;
        padding-top: 15px;
        font-weight: 700;
      }
    }
  }
`;
